var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'ds-sidebar-container',
    {
      'ds-opened': _vm.opened,
      'ds-collapsed': _vm.collapsed,
      'ds-disabled': _vm.disabled,
      'ds-alt': _vm.alt
    }
  ]},[_c('div',{staticClass:"ds-sidebar"},[_c('div',{staticClass:"ds-header"},[_vm._t("header",[_c('div',{staticClass:"ds-header-default"},[_vm._v("\n          Sidebar header\n        ")])])],2),_c('div',{staticClass:"ds-items"},[_vm._l((_vm.itemsWrapper),function(item,index){return [_c('div',{staticClass:"ds-item-wrapper"},[_c('a',{key:_vm.activeKey(item, index),class:[
              'ds-item',
              {
                'ds-active':
                  _vm.isActive(item, index) ||
                  _vm.temporaryActiveItem === _vm.activeKey(item, index),
                'ds-disabled': _vm.disabled || item.disabled,
                'ds-item-opened':
                  _vm.isItemHaveChild(item) ||
                  _vm.temporaryActiveItem === _vm.activeKey(item, index)
              }
            ],attrs:{"href":item.href,"tabindex":!_vm.disabled && !item.disabled && 0},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }$event.preventDefault();return _vm.itemClick(item, index, null, $event)},"click":function($event){return _vm.itemClick(item, index, null, $event)}}},[(item.icon)?_c('Icon',{attrs:{"source":item.icon,"size":"22px","padding":"6px 0","color":"gray-400"}}):_vm._e(),_c('div',{staticClass:"ds-title"},[_vm._v(_vm._s(item.title))]),(item.badge)?_c('div',{staticClass:"ds-badge",style:({
                'background-color':
                  _vm.disabled || item.disabled
                    ? _vm.COLORS['gray-300']
                    : _vm.COLORS[item.badge.color] || item.badge.color || 'red'
              })},[_vm._v("\n              "+_vm._s(item.badge.text)+"\n            ")]):_vm._e(),(item.additionalIcon)?_c('Icon',{staticClass:"ds-sidebar-additional-icon",attrs:{"source":item.additionalIcon.source,"size":item.additionalIcon.size,"color":item.additionalIcon.color}}):_vm._e(),(item.children && item.children.length && !_vm.collapsed)?_c('Icon',{staticClass:"ds-expand-icon",attrs:{"source":(_vm.isActive(item, index) && _vm.subSectionOpened) ||
                (_vm.temporaryActiveItem === _vm.activeKey(item, index) &&
                  _vm.temporaryOpened)
                  ? 'expand_less'
                  : 'expand_more'}}):_vm._e()],1),_c('section',{key:index,class:[
              'ds-children',
              {
                'ds-opened':
                  (_vm.isActive(item, index) && _vm.subSectionOpened) ||
                  (_vm.temporaryActiveItem === _vm.activeKey(item, index) &&
                    _vm.temporaryOpened)
              }
            ]},_vm._l((item.children),function(child,childIndex){return _c('a',{key:_vm.activeKey(child, childIndex),class:[
                'ds-item',
                'ds-child-item',
                {
                  'ds-active': _vm.activeKey(child, childIndex) === _vm.activeChild,
                  'ds-disabled': _vm.disabled || child.disabled
                }
              ],attrs:{"href":item.href,"tabindex":!_vm.disabled &&
                  _vm.activeKey(item, index) === _vm.active &&
                  !child.disabled &&
                  0},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }$event.preventDefault();return _vm.itemClick(child, index, childIndex, $event)},"click":function($event){return _vm.itemClick(child, index, childIndex, $event)}}},[_vm._v("\n              "+_vm._s(child.title)+"\n            ")])}),0)])]})],2),_c('div',{staticClass:"ds-footer"},[_vm._t("footer")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }